import DOMPurify from 'dompurify';

/**
 * Серверный HTML разбора — только через DOMPurify с белым списком (NFR-6);
 * набор тегов и атрибутов совпадает с текущим SPA. Инлайн-стили и классы
 * снимаются заранее, ссылки получают rel="noopener noreferrer".
 */
const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'b',
  'i',
  'u',
  'h1',
  'h2',
  'h3',
  'ul',
  'ol',
  'li',
  'a',
  'blockquote',
];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

let hooked = false;
function ensureLinkHook(): void {
  if (hooked) return;
  hooked = true;
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
}

export function sanitizeSummaryHtml(raw: string): string {
  ensureLinkHook();
  const stripped = raw
    .replace(/\sstyle="[^"]*"/gi, '')
    .replace(/\sclass="[^"]*"/gi, '')
    .replace(/\sid="[^"]*"/gi, '');
  return DOMPurify.sanitize(stripped, { ALLOWED_TAGS, ALLOWED_ATTR });
}
